import { serverLogger, logServerEvent } from "./server/logger";
import { clientLogger } from "./client/logger";

// Export server logging utilities
export { serverLogger, logServerEvent };

// Export client logger
export { clientLogger };

// Export types
export type { Logger } from "pino";
export type ServerLogger = typeof serverLogger;
